import React from 'react'
import Login2FAPage from './Login2FAPage'

export * from './Login2FAPage'
export default React.memo(Login2FAPage)
